import { Booking, Dealer } from '../../modules/entities/Entities';
import { useBrandNavigate } from '../../modules/navigation/UseBrandNavigate';
import { PageRoutes } from '../../modules/navigation/PageRoutes';
import { UseBookingContextValue } from '../../modules/booking-state/UseBookingContextValue';

export function useAmendNavigate([bookingState, setBookingState]: UseBookingContextValue): (booking: Booking, dealer: Dealer) => void {
  const navigate = useBrandNavigate();

  return (_booking: Booking, dealer: Dealer) => {
    setBookingState({
      ...bookingState,
      selectedDealer: dealer,
    });

    navigate(PageRoutes.ServiceRequest);
  };
}
